import reducer from './reducers';

export { default as userOperations } from './operations';
export { default as userTypes } from './types';
export { default as userActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/user/index.js